export const truncateWithEllipsis = (
  text: string | undefined | null | any,
  characterCount: number
) => {
  // Convert to string and handle null/undefined/non-string values
  const stringText = text ? String(text) : "";
  if (!stringText) return "";
  if (stringText.length <= characterCount) {
    return stringText;
  } else {
    return stringText.slice(0, characterCount - 1) + "...";
  }
};
